import { Route, Routes, BrowserRouter as Router, Navigate } from 'react-router-dom';
import { handleSetIsMobile } from 'reduxx/actions/general';
import { Fragment } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useEffect } from "react";

import LangWrapper from './langWrapper';
import Main from './pages/main';
import Products from './pages/products';
import Categories from './pages/categories';
import CategoryProducts from './pages/categories/products';
import ProjectDetails from './pages/products/details';
import ProductDetails from './pages/products/detailsMobile';
import ProductDetailsDesktop from './pages/products/detailsDesktop';
import SurgeryConsultation from './pages/surgeryConsultation';
import AboutUs from './pages/aboutUs';
import ContactUs from './pages/contactUs';
import Header from './partials/header';


import ScrollToTop from './partials/ScrollToTop';
import BackDrop from './partials/BackDrop';
import SupportIcons from './partials/SupportIcons';
import Snackbar from './partials/snackbar';
import ImportModals from './partials/ImportModals';



const Root = () => {

    const dispatch = useDispatch();

    const { isMobile } = useSelector(state => state.general);

    useEffect(() => {
        dispatch(handleSetIsMobile(window.innerWidth < 1024));
        document.documentElement.style.setProperty('--window-inner-height', (window.innerHeight + 'px'));

        const handleResize = () => {
            dispatch(handleSetIsMobile(window.innerWidth < 1024));
            document.documentElement.style.setProperty('--window-inner-height', (window.innerHeight + 'px'));
        };

        window.addEventListener("resize", handleResize);
        return () => window.removeEventListener("resize", handleResize);
    }, []);

    return (
        <Router>
            <Fragment>

                <svg style={{display: 'none'}}>
                    <symbol id="arrowLeft" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24"><path fillRule="evenodd" d="M11.293 19.707l1.414-1.414L7.414 13H20v-2H7.414l5.293-5.293-1.414-1.414-7 7a1 1 0 000 1.414l7 7z" clipRule="evenodd"></path></symbol>
                    <symbol id="arrowRight" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24"><path fillRule="evenodd" d="M12.707 19.707l-1.414-1.414L16.586 13H4v-2h12.586l-5.293-5.293 1.414-1.414 7 7a1 1 0 010 1.414l-7 7z" clipRule="evenodd"></path></symbol>
                    <symbol id="crownIcon" viewBox="0 0 14 11" xmlns="http://www.w3.org/2000/svg">
                        <path d="M13.987 3.994q.001.01-.004.02l-1.418 6.209a.95.95 0 0 1-.345.558 1.03 1.03 0 0 1-.638.219H2.42c-.233 0-.458-.078-.637-.22a.95.95 0 0 1-.345-.557L.02 4.013q0-.008-.004-.018a.92.92 0 0 1 .093-.603.98.98 0 0 1 .456-.427c.196-.091.419-.118.633-.077s.408.149.553.305l2.104 2.17 2.238-4.8V.556a.97.97 0 0 1 .37-.405 1.03 1.03 0 0 1 1.078 0 .97.97 0 0 1 .369.405v.006l2.238 4.8 2.105-2.17c.144-.155.338-.261.552-.302a1.04 1.04 0 0 1 .63.077.97.97 0 0 1 .455.426.92.92 0 0 1 .095.601z"
                            fill="currentColor"/>
                    </symbol>
                    <symbol id="arrowCircleLeft" viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg">
                        <circle cx="10" cy="10" r="10" fill="var(--icon-bg, #095250)" />
                        <path d="M11.412 14.275a.405.405 0 0 1 0 .575.406.406 0 0 1-.574 0l-4.063-4.063a.406.406 0 0 1 0-.574l4.063-4.063a.406.406 0 1 1 .574.575L7.637 10.5z"
                            fill="var(--icon-fg, #ffffff)" />
                    </symbol>
                </svg>

                <ScrollToTop />
                <BackDrop />
                <Snackbar />
                <Header />
                
                <Routes> 

                    <Route path='/:lng' element={<LangWrapper><Main /></LangWrapper>} />
                    <Route path="/:lng/products" element={<LangWrapper><Products /></LangWrapper>} />
                    <Route path="/:lng/categories" element={<LangWrapper><Categories /></LangWrapper>} />
                    <Route path="/:lng/category/:catId" element={<LangWrapper><CategoryProducts /></LangWrapper>} />
                    {/*<Route path="/:lng/product/:catId/:catTitle" element={<LangWrapper><ProductDetails /></LangWrapper>} />*/}
                    <Route path="/:lng/product/:catId/:catTitle" element={isMobile ? <LangWrapper><ProductDetails /></LangWrapper> : <LangWrapper><ProductDetailsDesktop /></LangWrapper>} />
                    <Route path="/:lng/project/:catId/:catTitle" element={<LangWrapper><ProjectDetails /></LangWrapper>} />
                    <Route path="/:lng/article/:catId/:catTitle" element={<LangWrapper><ProjectDetails /></LangWrapper>} />
                    <Route path="/:lng/consultation" element={<LangWrapper><SurgeryConsultation /></LangWrapper>} />
                    <Route path="/:lng/about-us" element={<LangWrapper><AboutUs /></LangWrapper>} />
                    <Route path="/:lng/contact-us" element={<LangWrapper><ContactUs /></LangWrapper>} />

                    
                    
                    <Route path='*' element={<Navigate replace to={ "/fa" }/>} />
                                      
                </Routes>
                <SupportIcons />
                <ImportModals />
            </Fragment>
        </Router>
    );

}

export default Root;
